import { SEND_NOTIFICATION } from "reducers/NotificationReducer";
import { store } from "store";

export const notificationMiddleWare = {
  afterSuccess: ({ instance, currentState, response }) => {
    store.dispatch({
      type: SEND_NOTIFICATION,
      payload: { message: response.message,variant : "success" },
    });
  },
  onError: ({ instance, currentState, response }) => {
    store.dispatch({
      type: SEND_NOTIFICATION,
      payload: { message: response.error.message,variant : "error" },
    });
  },
};
